import Home from '../Pages/Home';
import UserHome from '../Pages/HomeUser';
import Login from '../Pages/Login';
import Subject from '../Pages/Subject';
import Account from '../Pages/Account';
import Exams from '../Pages/Exams';
import DoExam from '../Pages/UserDoExam';
import TermsOfService from '../Pages/TermsOfService';
import PrivacyPolicy from '../Pages/PrivacyPolicy';
//Public Route
const privateRoutes = [
    { path: '/', component: Home },
    { path: '/chuyende/:id', component: Subject },
    { path: '/account', component: Account },
    { path: '/baithi', component: Exams },
];
const privateRoutesUser = [
    { path: '/', component: UserHome },
    { path: '/doexam/:id', component: DoExam },
];
const publicRoutes = [
    { path: '/login', component: Login, layout: null },
    { path: '/terms-of-service', component: TermsOfService, layout: null },
    { path: '/privacy-policy', component: PrivacyPolicy, layout: null },

];
export { publicRoutes, privateRoutes, privateRoutesUser }